module.exports = __webpack_public_path__ + "img/new-bt-pay.fb0a2e1c.png";